import type { FC, ReactNode } from "react";
import useFCMToken from "@ch/helpers/utils/firebase/hooks/useFCMToken";
import useNotificationListeners from "@ch/helpers/utils/firebase/hooks/useNotificationListeners";
import useBackgroundNotificationTracking from "@ch/helpers/utils/firebase/hooks/useBackgroundNotificationTracking";

interface NotificationProviderProps {
  children: ReactNode;
}

const NotificationProvider: FC<NotificationProviderProps> = ({ children }) => {
  useFCMToken();
  useNotificationListeners();
  useBackgroundNotificationTracking();

  return children;
};

export default NotificationProvider;
